var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.livechat8x8uuid)?_c('div',{ref:"livechat8x8",staticClass:"livechat8x8",style:({
  position:_vm.error?'fixed':'sticky',
  bottom:_vm.error?'10px':'auto',
  right:_vm.error?'10px':'auto',
  textAlign:'right',
  width:'min-content',
  alignSelf:'flex-end'}),attrs:{"id":("__8x8-chat-button-container-" + _vm.livechat8x8uuid)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }